export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_CURRENT_USER_UI_FLAGS: 'SET_CURRENT_USER_UI_FLAGS',
  TOGGLE_CONVERSATION_SECONDARY_SIDEBAR:
    'TOGGLE_CONVERSATION_SECONDARY_SIDEBAR',
  SHOW_CONVERSATION_SECONDARY_SIDEBAR: 'SHOW_CONVERSATION_SECONDARY_SIDEBAR',
  HIDE_CONVERSATION_SECONDARY_SIDEBAR: 'HIDE_CONVERSATION_SECONDARY_SIDEBAR',
  SET_CURRENT_ACTIVE_ROUTE: 'SET_CURRENT_ACTIVE_ROUTE',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  CHANGE_CHAT_SORT_FILTER: 'CHANGE_CHAT_SORT_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',
  SET_CONVERSATION_LAST_SEEN: 'SET_CONVERSATION_LAST_SEEN',
  SET_LAST_MESSAGE_ID_IN_SYNC_CONVERSATION:
    'SET_LAST_MESSAGE_ID_FOR_SYNC_CONVERSATION',
  SET_DRAFT_MESSAGES: 'SET_DRAFT_MESSAGES',
  REMOVE_DRAFT_MESSAGES: 'REMOVE_DRAFT_MESSAGES',
  SET_REPLY_EDITOR_MODE: 'SET_REPLY_EDITOR_MODE',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  UPDATE_CONVERSATION_MESSAGES: 'UPDATE_CONVERSATION_MESSAGES',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  UPDATE_MESSAGE_UNREAD_COUNT: 'UPDATE_MESSAGE_UNREAD_COUNT',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',
  UPDATE_CONVERSATION_LAST_ACTIVITY: 'UPDATE_CONVERSATION_LAST_ACTIVITY',
  SET_MISSING_MESSAGES: 'SET_MISSING_MESSAGES',
  SET_CURRENT_CHAT_DISPLAY_SETTINGS: 'SET_CURRENT_CHAT_DISPLAY_SETTINGS',

  SET_ALL_ATTACHMENTS: 'SET_ALL_ATTACHMENTS',
  ADD_CONVERSATION_ATTACHMENTS: 'ADD_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION_ATTACHMENTS: 'DELETE_CONVERSATION_ATTACHMENTS',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',

  SET_CONTEXT_MENU_CHAT_ID: 'SET_CONTEXT_MENU_CHAT_ID',

  SET_CHAT_LIST_FILTERS: 'SET_CHAT_LIST_FILTERS',
  UPDATE_CHAT_LIST_FILTERS: 'UPDATE_CHAT_LIST_FILTERS',

  SET_MESSAGES_UI_FLAG: 'SET_MESSAGES_UI_FLAG',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOX_ITEM: 'SET_INBOX_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',
  SHARED_INBOX_FLAG: 'SHARED_INBOX_FLAG',
  SET_ONBOARDING_URL: 'SET_ONBOARDING_URL',
  SET_PHOENIX_SUGGESTION_CONFIG: 'SET_PHOENIX_SUGGESTION_CONFIG',
  DELETE_PHOENIX_SUGGESTION_CONFIG: 'DELETE_PHOENIX_SUGGESTION_CONFIG',
  SET_PHOENIX_IMPROVE_CONFIG: 'SET_PHOENIX_IMPROVE_CONFIG',
  DELETE_PHOENIX_IMPROVE_CONFIG: 'DELETE_PHOENIX_IMPROVE_CONFIG',

  // Agent
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNT_LIMITS: 'SET_ACCOUNT_LIMITS',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_AGENT',

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',
  UPDATE_SINGLE_AGENT_PRESENCE: 'UPDATE_SINGLE_AGENT_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Credentials
  SET_CREDENTIAL_UI_FLAG: 'SET_CREDENTIAL_UI_FLAG',
  SET_CREDENTIALS: 'SET_CREDENTIALS',
  SET_CREDENTIAL: 'SET_CREDENTIAL',
  ADD_CREDENTIAL: 'ADD_CREDENTIAL',
  EDIT_CREDENTIAL: 'EDIT_CREDENTIAL',
  DELETE_CREDENTIAL: 'DELETE_CREDENTIAL',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',

  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  ADD_CONTACT_TO_LIST: 'ADD_CONTACT_TO_LIST',
  SET_CONTACTS: 'SET_CONTACTS',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  CLEAR_CONTACT_LISTS: 'CLEAR_CONTACTS_LISTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',
  SET_CONTACT_CONDITION: 'SET_CONTACT_CONDITION',
  CLEAR_CONTACT_CONDITION: 'CLEAR_CONTACT_CONDITION',
  SET_ALL_CONTACTS: 'SET_ALL_CONTACTS',
  CLEAR_ALL_CONTACTS: 'CLEAR_ALL_CONTACTS',
  SET_ALL_CONTACTS_META: 'SET_ALL_CONTACTS_META',
  CLEAR_ALL_CONTACTS_META: 'CLEAR_ALL_CONTACTS_META',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_READ_NOTIFICATIONS_META: 'SET_READ_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  READ_NOTIFICATION: 'READ_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  SET_READ_NOTIFICATIONS: 'SET_READ_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  CLEAR_READ_NOTIFICATIONS: 'CLEAR_READ_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',
  SET_ALL_NOTIFICATIONS_LOADED: 'SET_ALL_NOTIFICATIONS_LOADED',
  DELETE_READ_NOTIFICATIONS: 'DELETE_READ_NOTIFICATIONS',
  DELETE_ALL_NOTIFICATIONS: 'DELETE_ALL_NOTIFICATIONS',
  SNOOZE_NOTIFICATION: 'SNOOZE_NOTIFICATION',
  SET_NOTIFICATION_FILTERS: 'SET_NOTIFICATION_FILTERS',
  UPDATE_NOTIFICATION_FILTERS: 'UPDATE_NOTIFICATION_FILTERS',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',
  SET_CONTACT_LISTS: 'SET_CONTACT_LISTS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',
  SET_SELECTED_CONVERSATION_IDS: 'SET_SELECTED_CONVERSATION_IDS',
  CLEAR_SELECTED_CONVERSATION_IDS: 'CLEAR_SELECTED_CONVERSATION_IDS',
  REMOVE_SELECTED_CONVERSATION_IDS: 'REMOVE_SELECTED_CONVERSATION_IDS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_HEATMAP_DATA: 'SET_HEATMAP_DATA',
  TOGGLE_HEATMAP_LOADING: 'TOGGLE_HEATMAP_LOADING',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  SET_BOT_SUMMARY: 'SET_BOT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_ACCOUNT_CONVERSATION_METRIC: 'SET_ACCOUNT_CONVERSATION_METRIC',
  TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING',
  SET_AGENT_CONVERSATION_METRIC: 'SET_AGENT_CONVERSATION_METRIC',
  TOGGLE_AGENT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_AGENT_CONVERSATION_METRIC_LOADING',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',

  // Automations
  SET_AUTOMATION_UI_FLAG: 'SET_AUTOMATION_UI_FLAG',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  EDIT_AUTOMATION: 'EDIT_AUTOMATION',
  DELETE_AUTOMATION: 'DELETE_AUTOMATION',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  UPDATE_CUSTOM_VIEW: 'UPDATE_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',
  SET_ACTIVE_CONVERSATION_FOLDER: 'SET_ACTIVE_CONVERSATION_FOLDER',

  // Bulk Actions
  SET_BULK_ACTIONS_FLAG: 'SET_BULK_ACTIONS_FLAG',

  // Dashboard Apps
  SET_DASHBOARD_APPS_UI_FLAG: 'SET_DASHBOARD_APPS_UI_FLAG',
  SET_DASHBOARD_APPS: 'SET_DASHBOARD_APPS',
  CREATE_DASHBOARD_APP: 'CREATE_DASHBOARD_APP',
  EDIT_DASHBOARD_APP: 'EDIT_DASHBOARD_APP',
  DELETE_DASHBOARD_APP: 'DELETE_DASHBOARD_APP',

  // Help center
  ADD_ARTICLE: 'ADD_ARTICLE',
  ADD_ARTICLE_ID: 'ADD_ARTICLE_ID',
  ADD_MANY_ARTICLES: 'ADD_MANY_ARTICLES',
  ADD_MANY_ARTICLES_ID: 'ADD_MANY_ARTICLES_ID',
  SET_ARTICLES_META: 'SET_ARTICLES_META',
  UPDATE_ARTICLE_FLAG: 'UPDATE_ARTICLE_FLAG',
  ADD_ARTICLE_FLAG: 'ADD_ARTICLE_FLAG',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  CLEAR_ARTICLES: 'CLEAR_ARTICLES',
  REMOVE_ARTICLE: 'REMOVE_ARTICLE',
  REMOVE_ARTICLE_ID: 'REMOVE_ARTICLE_ID',
  SET_UI_FLAG: 'SET_UI_FLAG',

  // Help Center -- Categories
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_ID: 'ADD_CATEGORY_ID',
  ADD_MANY_CATEGORIES: 'ADD_MANY_CATEGORIES',
  ADD_MANY_CATEGORIES_ID: 'ADD_MANY_CATEGORIES_ID',
  ADD_CATEGORY_FLAG: 'ADD_CATEGORY_FLAG',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_CATEGORY_ID: 'REMOVE_CATEGORY_ID',

  // Agent Bots
  SET_AGENT_BOT_UI_FLAG: 'SET_AGENT_BOT_UI_FLAG',
  SET_AGENT_BOTS: 'SET_AGENT_BOTS',
  ADD_AGENT_BOT: 'ADD_AGENT_BOT',
  EDIT_AGENT_BOT: 'EDIT_AGENT_BOT',
  DELETE_AGENT_BOT: 'DELETE_AGENT_BOT',
  SET_AGENT_BOT_INBOX: 'SET_AGENT_BOT_INBOX',

  // MACROS
  SET_MACROS_UI_FLAG: 'SET_MACROS_UI_FLAG',
  SET_MACROS: 'SET_MACROS',
  ADD_MACRO: 'ADD_MACRO',
  EDIT_MACRO: 'EDIT_MACRO',
  DELETE_MACRO: 'DELETE_MACRO',

  // Full Search
  FULL_SEARCH_SET: 'FULL_SEARCH_SET',
  CONTACT_SEARCH_SET: 'CONTACT_SEARCH_SET',
  CONTACT_SEARCH_SET_UI_FLAG: 'CONTACT_SEARCH_SET_UI_FLAG',
  CONVERSATION_SEARCH_SET: 'CONVERSATION_SEARCH_SET',
  CONVERSATION_SEARCH_SET_UI_FLAG: 'CONVERSATION_SEARCH_SET_UI_FLAG',
  MESSAGE_SEARCH_SET: 'MESSAGE_SEARCH_SET',
  MESSAGE_SEARCH_SET_UI_FLAG: 'MESSAGE_SEARCH_SET_UI_FLAG',
  FULL_SEARCH_SET_UI_FLAG: 'FULL_SEARCH_SET_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS_UI_FLAG:
    'SET_CONVERSATION_PARTICIPANTS_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS: 'SET_CONVERSATION_PARTICIPANTS',

  // LISTS
  SET_LISTS: 'SET_LISTS',
  SET_EXCLUDED_CONTACTS: 'SET_EXCLUDED_CONTACTS',
  SET_NEW_LISTS: 'SET_NEW_LISTS',
  SET_LIST: 'SET_LIST',
  UPDATE_LIST: 'UPDATE_LIST',
  EDIT_CONTACT_IN_LIST: 'EDIT_CONTACT_IN_LIST',
  SET_LIST_META: 'SET_LIST_META',
  SET_LIST_LINKS: 'SET_LIST_LINKS',
  SET_LISTS_UI_FLAGS: 'SET_LISTS_UI_FLAGS',
  SET_LIST_ENTRYPOINTS: 'SET_LIST_ENTRYPOINTS',
  SET_LIST_CONDITION: 'SET_LIST_CONDITION',
  SET_LIST_CONDITIONS: 'SET_LIST_CONDITIONS',
  CLEAR_LISTS: 'CLEAR_LISTS',
  CLEAR_LIST: 'CLEAR_LIST',
  CLEAR_LIST_META: 'CLEAR_LIST_META',
  CLEAR_LIST_LINKS: 'CLEAR_LIST_LINKS',
  CLEAR_LISTS_STATE: 'CLEAR_LISTS_STATE',
  CLEAR_LIST_ENTRYPOINTS: 'CLEAR_LIST_ENTRYPOINTS',
  CLEAR_LIST_CONDITION: 'CLEAR_LIST_CONDITION',
  CLEAR_LIST_CONDITIONS: 'CLEAR_LIST_CONDITIONS',

  // MESSAGE TEMPLATES
  SET_MESSAGE_TEMPLATES: 'SET_MESSAGE_TEMPLATES',
  APPEND_MESSAGE_TEMPLATES: 'APPEND_MESSAGE_TEMPLATES',
  SET_MESSAGE_TEMPLATES_NAME: 'SET_MESSAGE_TEMPLATES_NAME',
  SET_MESSAGE_TEMPLATES_META: 'SET_MESSAGE_TEMPLATES_META',
  SET_MESSAGE_TEMPLATE: 'SET_MESSAGE_TEMPLATE',
  SET_MESSAGE_TEMPLATE_UI_FLAGS: 'SET_MESSAGE_TEMPLATE_UI_FLAGS',
  SET_MESSAGE_TEMPLATE_COUNT: 'SET_MESSAGE_TEMPLATE_COUNT',
  SET_MESSAGE_TEMPLATE_ENTRYPOINTS: 'SET_MESSAGE_TEMPLATE_ENTRYPOINTS',
  CLEAR_MESSAGE_TEMPLATES: 'CLEAR_MESSAGE_TEMPLATES',
  CLEAR_MESSAGE_TEMPLATES_META: 'CLEAR_MESSAGE_TEMPLATES_META',
  CLEAR_MESSAGE_TEMPLATE: 'CLEAR_MESSAGE_TEMPLATE',
  CLEAR_MESSAGE_TEMPLATE_COUNT: 'CLEAR_MESSAGE_TEMPLATE_COUNT',
  CLEAR_MESSAGE_TEMPLATE_ENTRYPOINTS: 'CLEAR_MESSAGE_TEMPLATE_ENTRYPOINTS',
  SET_SCHEDULED_MESSAGE_TEMPLATES: 'SET_SCHEDULED_MESSAGE_TEMPLATES',
  SET_SCHEDULED_MESSAGE_TEMPLATE: 'SET_SCHEDULED_MESSAGE_TEMPLATE',
  CLEAR_SCHEDULED_MESSAGE_TEMPLATES: 'CLEAR_SCHEDULED_MESSAGE_TEMPLATES',
  CLEAR_SCHEDULED_MESSAGE_TEMPLATE: 'CLEAR_SCHEDULED_MESSAGE_TEMPLATE',
  SET_DELETING_MESSAGE_TEMPLATE: 'SET_DELETING_MESSAGE_TEMPLATE',
  CLEAR_DELETING_MESSAGE_TEMPLATE: 'CLEAR_DELETING_MESSAGE_TEMPLATE',
  CLEAR_DELETING_MESSAGE_TEMPLATES: 'CLEAR_DELETING_MESSAGE_TEMPLATES',

  // MANAGEMENT
  SET_MANAGEMENT_UI_FLAGS: 'SET_MANAGEMENT_UI_FLAGS',
  SET_MANAGEMENT_USER_LANGUAGE: 'SET_MANAGEMENT_USER_LANGUAGE',
  SET_MANAGEMENT_USER_PROFILE_DETAILS: 'SET_MANAGEMENT_USER_PROFILE_DETAILS',
  SET_MANAGEMENT_ACCOUNT: 'SET_MANAGEMENT_ACCOUNT',
  SET_MANAGEMENT_CHAT_BUBBLES: 'SET_MANAGEMENT_CHAT_BUBBLES',
  SET_MANAGEMENT_SIGNATURES: 'SET_MANAGEMENT_SIGNATURES',
  SET_MANAGEMENT_INBOX_OPT_OUT: 'SET_MANAGEMENT_INBOX_OPT_OUT',
  SET_MANAGEMENT_SMS: 'SET_MANAGEMENT_SMS',
  SET_MANAGEMENT_INBOX_OPT_OUTS: 'SET_MANAGEMENT_INBOX_OPT_OUTS',
  CLEAR_MANAGEMENT_USER_PROFILE_DETAILS:
    'CLEAR_MANAGEMENT_USER_PROFILE_DETAILS',
  CLEAR_MANAGEMENT_CHAT_BUBBLES: 'CLEAR_MANAGEMENT_CHAT_BUBBLES',
  CLEAR_MANAGEMENT_SIGNATURES: 'CLEAR_MANAGEMENT_SIGNATURES',
  CLEAR_MANAGEMENT_INBOX_OPT_OUT: 'CLEAR_MANAGEMENT_INBOX_OPT_OUT',
  CLEAR_MANAGEMENT_SMS: 'CLEAR_MANAGEMENT_SMS',
  CLEAR_MANAGEMENT_INBOX_OPT_OUTS: 'CLEAR_MANAGEMENT_INBOX_OPT_OUTS',
  SET_MANAGEMENT_KEYSTONE_FLOWS: 'SET_MANAGEMENT_KEYSTONE_FLOWS',
  CLEAR_MANAGEMENT_KEYSTONE_FLOWS: 'CLEAR_MANAGEMENT_KEYSTONE_FLOWS',

  // Audit Logs
  SET_AUDIT_LOGS_UI_FLAG: 'SET_AUDIT_LOGS_UI_FLAG',
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  SET_AUDIT_LOGS_META: 'SET_AUDIT_LOGS_META',

  // Automations
  SET_ALL_ENTRYPOINT: 'SET_ALL_ENTRYPOINT',
  SET_ENTRYPOINT: 'SET_ENTRYPOINT',
  SET_ENTRYPOINT_UI_FLAGS: 'SET_ENTRYPOINT_UI_FLAGS',
  CLEAR_ALL_ENTRYPOINT: 'CLEAR_ALL_ENTRYPOINT',
  CLEAR_ENTRYPOINT: 'CLEAR_ENTRYPOINT',

  // Deepl
  SET_DEEPL_UI_FLAGS: 'SET_DEEPL_UI_FLAGS',
  SET_DEEPL_LANGUAGES: 'SET_LANGUAGES',
  CLEAR_DEEPL_LANGUAGES: 'CLEAR_LANGUAGES',

  // Chatbot
  SET_CHATBOT_HANDOVER: 'SET_CHATBOT_HANDOVER',
  CLEAR_CHATBOT_HANDOVER: 'CLEAR_CHATBOT_HANDOVER',
  SET_CHATBOT_CONVERSATION_STATUS: 'SET_CHATBOT_CONVERSATION_STATUS',
  CLEAT_CHATBOT_CONVERSATION_STATUS: 'CLEAT_CHATBOT_CONVERSATION_STATUS',
  SET_CHATBOT_AI_NESTS: 'SET_CHATBOT_AI_NESTS',
  CLEAR_CHATBOT_AI_NESTS: 'CLEAR_CHATBOT_AI_NESTS',
  SET_CHATBOT_AI_SUGGESTIONS: 'SET_CHATBOT_AI_SUGGESTIONS',
  CLEAR_CHATBOT_AI_SUGGESTIONS: 'CLEAR_CHATBOT_AI_SUGGESTIONS',
  SET_CHATBOT_AI_IMPROVEMENT: 'SET_CHATBOT_AI_IMPROVEMENT',
  CLEAR_CHATBOT_AI_IMPROVEMENT: 'CLEAR_CHATBOT_AI_IMPROVEMENT',
  SET_CHATBOT_CONVERSATIONS_STATUSES_STATE:
    'SET_CHATBOT_CONVERSATIONS_STATUSES_STATE',
  SET_CHATBOT_UI_FLAGS: 'SET_CHATBOT_UI_FLAGS',

  // Folders
  SET_FOLDERS_UI_FLAGS: 'SET_FOLDERS_UI_FLAGS',
  SET_FOLDERS: 'SET_FOLDERS',
  SET_FOLDER: 'SET_FOLDER',
  SET_FOLDERS_STATE: 'SET_FOLDERS_STATE',
  SET_FOLDER_ENTRYPOINTS: 'SET_FOLDER_ENTRYPOINTS',
  CLEAR_FOLDERS: 'CLEAR_FOLDERS',
  CLEAR_FOLDER: 'CLEAR_FOLDER',

  // SLA
  SET_SLA_UI_FLAG: 'SET_SLA_UI_FLAG',
  SET_SLA: 'SET_SLA',
  ADD_SLA: 'ADD_SLA',
  EDIT_SLA: 'EDIT_SLA',
  DELETE_SLA: 'DELETE_SLA',

  // SLA Reports
  SET_SLA_REPORTS_UI_FLAG: 'SET_SLA_REPORTS_UI_FLAG',
  SET_SLA_REPORTS: 'SET_SLA_REPORTS',
  SET_SLA_REPORTS_METRICS: 'SET_SLA_REPORTS_METRICS',
  SET_SLA_REPORTS_META: 'SET_SLA_REPORTS_META',
  CLEAR_FOLDER_ENTRYPOINTS: 'CLEAR_FOLDER_ENTRYPOINTS',

  SET_BRANDNAMIC_CONTACTS: 'SET_BRANDNAMIC_CONTACTS',
  SET_BRANDNAMIC_CONTACT: 'SET_BRANDNAMIC_CONTACT',
  SET_BRANDNAMIC_META: 'SET_BRANDNAMIC_META',
  SET_BRANDNAMIC_FETCHING_UI_FLAG: 'SET_BRANDNAMIC_FETCHING_UI_FLAG',
  SET_BRANDNAMIC_PERSONALITIES_MAP: 'SET_BRANDNAMIC_PERSONALITIES_MAP',
  SET_SELECTED_PERSONALITIES: 'SET_SELECTED_PERSONALITIES',
  SET_BRANDNAMIC_ACTIVE_PERSONALITY: 'SET_BRANDNAMIC_ACTIVE_PERSONALITY',

  // Payments
  SET_PAYMENTS_UI_FLAG: 'SET_PAYMENTS_UI_FLAG',
  SET_PAYMENTS_ACCOUNT: 'SET_PAYMENTS_ACCOUNT',
  SET_PAYMENTS_INVOICES: 'SET_PAYMENTS_INVOICES',
  CLEAR_PAYMENTS_ACCOUNT: 'CLEAR_PAYMENTS_ACCOUNT',
  CLEAR_PAYMENTS_INVOICES: 'CLEAR_PAYMENTS_INVOICES',
  SET_PAYMENT_STATUS: 'SET_PAYMENT_STATUS',
  CLEAR_PAYMENT_STATUS: 'CLEAR_PAYMENT_STATUS',

  // Guest Journey
  SET_GUEST_JOURNEY_UI_FLAG: 'SET_GUEST_JOURNEY_UI_FLAG',
  SET_PMS_CONNECTION_STATUS: 'SET_PMS_CONNECTION_STATUS',
  SET_RESERVATIONS: 'SET_RESERVATIONS',
  SET_FETCHING_RESERVATIONS: 'SET_FETCHING_RESERVATIONS',
  SET_FETCH_RESERVATIONS_ERROR: 'SET_FETCH_RESERVATIONS_ERROR',
  SET_GUEST_JOURNEY_FETCH_STATUS_ERROR: 'SET_GUEST_JOURNEY_FETCH_STATUS_ERROR',
};
